import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import { Card, CardBody, Col, Container, FormGroup, Label, Row, Table , Button, Popover, PopoverBody, PopoverHeader} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import withReducer from "../../../store/withReducer";
// import useNavigate from 'react-router-dom';

import { downloadTrackingInvoice, getTrackingItem, openNewTrackingDialog, setInvoiceSalesReturnData, setOrderData, setOrderTrackingDetils, setReturnOrderData, setTrackingData, setUnfulfillmentStatus, showOrder, showTrackingInvoice, syncOrderTracking } from "../store/orderSlice";
import { useHistory, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import Select from "react-select";
import orderReducer from "../store";
import { TrackOrder } from "./section/trackOrder";
import { ShippingInformation } from "./section/shippingInformation";
import { BillingInformation } from "./section/billingInformation";
import { Item } from "./section/item";
import { RefundedItem } from "./section/refundedItem";
import { showSeller } from "../../seller/store/sellerSlice";
import PreLoader from "../../../share-components/ui/preLoader";
import { Details } from "../tracking/content/details";
import ReturnProcessTimeline from "../pending-return/view/content/ReturnProcessTimeline";
import ReportContent from "./section/reportContents";

const ViewOrder = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  let history = useHistory();
  const [loading, isSetLoading] = useState(false);
  const [resendButtonDisabled, setResendButtonDisabled] = useState(false);
  const [syncTrackingButtonDisabled, setSyncTrackingButtonDisabled] = useState(false);
  const [syncButtonDisabledMap, setSyncButtonDisabledMap] = useState({});
  const orderState = useSelector(({ order }) => order.order);
  const userState = useSelector(({ authReducer }) => authReducer.data);
  const authData = useSelector(({ authReducer }) => authReducer);
  const dataMenu = [
    {
      type: 1,
      text: "Orders",
      link: "/order",
    },
    {
      type: 0,
      text: "View Order",
    },
  ];


  useEffect(() => {
    isSetLoading(true);
    if (id !== undefined) {
      const data = {
        id,
        params: { seller: authData.defaultSeller?.value },
      };

      dispatch(showOrder(data)).then((res) => {
        if (!res.error) {
          isSetLoading(false);
          dispatch(setReturnOrderData(res.payload));
          dispatch(setOrderData(res.payload));
          dispatch(setInvoiceSalesReturnData(res.payload.partner_invoice_actions))
        }
        isSetLoading(false);
      });
    }
  }, [dispatch, authData.defaultSeller, id]);

  const retrieveTrackingDetails = (id) => {
    dispatch(getTrackingItem(id)).then((res) => {
      if (!res.error) {
        dispatch(setTrackingData(res.payload));
      }
    });
  };

  const fetchView = () => {        
      dispatch(showTrackingInvoice(id)).then(res => {
          if (!res.error) {
              dispatch(setOrderTrackingDetils(res.payload));
              isSetLoading(false);
          }
      });
  }

  const syncTrackingClick = (tracking_id) => {
      setSyncButtonDisabledMap(prev => ({ ...prev, [tracking_id]: true }));
          const payload = {
          tracking_id: tracking_id
      }
      dispatch(syncOrderTracking({ ...payload })).then(res => {
          setSyncButtonDisabledMap(prev => ({ ...prev, [tracking_id]: false }));
          fetchView();
      });
  }

  const PopoverSyncTracking = (props) => {
    const {list} = props;
    const [popover, setPopover] = useState(false)
    const Toggle = () => setPopover(!popover);
    return (
        <>
            <Button color="primary" size="xs" type="button" className="" id={"SyncTrackingPopover-" + list.tracking.id} 
                onClick={() => {
                    syncTrackingClick(list.tracking.id)
                }} 
                disabled={syncButtonDisabledMap[list.tracking.id] || list.can_sync_tracking_status == 2}>
                    {syncButtonDisabledMap[list.tracking.id] && <i className="fa fa-spinner fa-spin" />} Fetch Tracking Status
            </Button>
            {(list.can_sync_tracking_status == 2) && (
                <Popover
                    placement="top"
                    isOpen={popover}
                    target={"SyncTrackingPopover-" + list.tracking.id}
                    toggle={Toggle}
                    trigger="hover"
                >
                    <PopoverBody>
                        You have reached the usage limit for today. Please try again tomorrow.
                    </PopoverBody>
                </Popover>
            )}
        </>
    );
  };

  console.log("orderState", orderState)

  return (
    <>
      {loading ? (
        <PreLoader />
      ) : (
        <Fragment>
          <Breadcrumb title="Orders" data={dataMenu} />
          <Container fluid={true}>
            <Row>
              <Col sm={3}>
                <TrackOrder orderState={orderState} />
                <ShippingInformation colSize={12} orderState={orderState} />
                <BillingInformation colSize={12} orderState={orderState} />
              </Col>
              <Col sm={9}>
                <Item retrieveTrackingDetails={retrieveTrackingDetails} orderId={id} orderState={orderState} authData={authData} />

                {userState.user.role.name != "Seller" && (
                  <>
                    <Col md={12}>
                      <RefundedItem orderState={orderState} />
                    </Col>
                  </>
                )}

                {orderState.trackingDetails ? orderState.trackingDetails.length > 0 && (
                    <Row style={{paddingLeft:15, paddingRight:15}}>

                        <Col sm={12}>
                            {orderState?.tracking_list && (() => {
                                // Flatten arrays in the exact order they appear in JSON
                                const allItems = Object.entries(orderState.tracking_list)
                                    .reduce((acc, [_, arr]) => acc.concat(arr || []), []);

                                // If you still want sorting by invoice_no (ignore "CG" prefix)
                                const sortedItems = [...allItems].sort((a, b) => {
                                    const numA = parseInt(a.invoice_no.replace("CG", ""), 10);
                                    const numB = parseInt(b.invoice_no.replace("CG", ""), 10);
                                    return numA - numB;
                                });

                                return sortedItems.map((list, index) => {
                                    if (!list?.tracking && !list?.tracking_summary) return null;

                                    return (
                                        <Card className="ribbon-wrapper" key={`${list.invoice_no || 'no-inv'}-${index}`}>
                                            <CardBody>
                                                <div className="ribbon ribbon-clip h6 ribbon-info">
                                                    {list.seller_name} (Invoice No: {list.invoice_no})
                                                </div>

                                                {(list.tracking && list.tracking.tracking_number) ? (
                                                    <div className="table-responsive">
                                                        <Table style={{ width: '100%', border: "none" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: '50%', paddingLeft: 0 }}>
                                                                        <p><strong>Tracking Details:</strong></p>
                                                                        <p><strong>Carrier:</strong> {list.tracking.tracking_name}</p>
                                                                        <p><strong>Tracking Number:</strong> {list.tracking.tracking_number}</p>
                                                                        <p>
                                                                            <strong>Tracking URL:</strong>{" "}
                                                                            <a
                                                                                style={{ textDecoration: 'underline', color: 'blue' }}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                href={list.tracking.tracking_url}
                                                                            >
                                                                                {list.tracking.tracking_url}
                                                                            </a>
                                                                        </p>
                                                                        {list.can_sync_tracking_status != 0 && (
                                                                            <p><PopoverSyncTracking list={list}/></p>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                ) : (
                                                    <div className="table-responsive">
                                                        Couldn't fetch Tracking details.
                                                    </div>
                                                )}

                                                {list.tracking_summary && (
                                                    <div className="mt-2 mb-5">
                                                        <h6>Tracking Status:</h6>
                                                        <ReturnProcessTimeline trackingSummary={list.tracking_summary} />
                                                    </div>
                                                )}
                                            </CardBody>
                                        </Card>
                                    );
                                });
                            })()}


                        </Col>
                    </Row>
                ) : ""}

                <ReportContent orderState={orderState}/>
              </Col>
            </Row>
          </Container>
        </Fragment>
      )}
    </>
  );
};

export default withReducer([{ order: orderReducer }])(ViewOrder);
